import { FormField } from '../interfaces/AppProps';

const estimateRowCount = (inputEntryFormFields: FormField[]): number => {
  return inputEntryFormFields.reduce((acc, item) => {
    if (item?.type === 'string') {
      if (item.start && item.includeStart === true) {
        return acc * item.start.split(',').length;
      } else if (item.start) {
        return acc * 1;
      }
      return acc;
    } else {
      let start = item.start ? parseFloat(item.start) : 0;
      let end = item.end ? parseFloat(item.end) : 0;
      let interval = item.interval ? parseFloat(item.interval) : 1;
      if (interval <= 0) return acc; // avoid infinite loop
      let count = Math.floor((end - start) / interval) + 2; // +2 for the edge cases in generateRows
      return acc * Math.max(count, 1);
    }
  }, 1);
};

export default estimateRowCount; 